import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Image, Header, Icon} from 'semantic-ui-react';

const icon = require('../img/icons/404.svg');

class UpgradePlan extends Component {

    render() {
        return (
            <div>
                <Helmet>
                    <title>Actualiza tu plan - Quipuu</title>
                </Helmet>
                <br/>
                <Header as='h1' icon textAlign='center'>
                    <Icon><Image centered src={icon} height={260} alt='logo'/></Icon>
                    <Header.Content>
                        Actualiza tu plan
                        <Header.Subheader>
                            Para ver esta característica y muchas más actualiza tu plan
                        </Header.Subheader>
                    </Header.Content>
                </Header>
            </div>
        );
    }
}

export default UpgradePlan;



// WEBPACK FOOTER //
// ./src/containers/UpgradePlan.js